<template>
  <div class="pop-over">
    <div>
      <h5>{{ $t('send_results.send_database') }}</h5>
      <div class="info-container">
        <pre id="json"> </pre>
      </div>
      <div class="footer">
        <div class="navigation-buttons">
        </div>

        <div class="navigation-buttons" @click="close">
          <button class="btn btn-outline-dark next" type="submit">
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewCollectedData',
  watch: {},
  methods: {
    close() {
      this.$emit("close");
    },
  },
  mounted() {
    document.getElementById("json").textContent = JSON.stringify(this.$store.state.calculatedSummaryData, null, 4);
    // console.log(JSON.stringify(this.$store.state.calculatedSummaryData))
  }
};
</script>

<style scoped>
.pop-over {
  padding: 2rem;
  background-color: #f0f0f2;
  position: fixed;
  margin-left: 30%;
  z-index: 20;
  height: 600px;
  width: 700px;
  margin-top: 4rem;
  border-radius: 15px;

}


.footer {
  display: grid;
  grid-gap: 10px;
  padding: 60px 10px 10px 0;
  grid-template-columns: 90% 10%;
}

.info-container {
  overflow-y: scroll;
  height: 400px;
  text-align: left;
}
#json{
  width: 600px;
}
</style>
